import CommonUtil from "../../utils/CommonUtil";

const ButtonComponent = ({ label, prefix, onClick, className }) => {
  return (
    <button
      className={CommonUtil.groupClass(
        "flex flex-row justify-between items-center gap-2 bg-primaryColor rounded-lg py-1 px-4 text-white font-bold hover:text-white hover:scale-105 transition",
        className
      )}
      onClick={() => onClick?.()}
    >
      {prefix}
      {label}
    </button>
  );
};
export default ButtonComponent;
